import { createAction } from 'redux-actions'
import {
  GET_SESSION,
  GET_SESSION_FAILED,
  GET_SESSION_SUCCEEDED,
  CREATE_SESSION,
  CREATE_SESSION_FAILED,
  CREATE_SESSION_SUCCEEDED,
  DESTROY_SESSION,
  DESTROY_SESSION_FAILED,
  DESTROY_SESSION_SUCCEEDED,
  CREATE_SESSION_BY_OAUTH2,
  CREATE_SESSION_BY_OAUTH2_FAILED,
  CREATE_SESSION_BY_OAUTH2_SUCCEEDED,
  GET_DROPBOX_OAUTH_URL,
  GET_DROPBOX_OAUTH_URL_FAILED,
  GET_DROPBOX_OAUTH_URL_SUCCEEDED,
  GET_OFFICE365_ACCESS_TOKEN,
  GET_OFFICE365_ACCESS_TOKEN_FAILED,
  GET_OFFICE365_ACCESS_TOKEN_SUCCEEDED,
  REFRESH_SESSION,
  REFRESH_SESSION_FAILED,
  REFRESH_SESSION_SUCCEEDED,
  INIT_AUTH_KEY,
  CLEAR_APP_STATE,
} from 'Redux/Types/SessionTypes'

export const getSession = createAction(GET_SESSION)
export const getSessionFailed = createAction(GET_SESSION_FAILED)
export const getSessionSucceeded = createAction(GET_SESSION_SUCCEEDED)

export const createSession = createAction(CREATE_SESSION)
export const createSessionFailed = createAction(CREATE_SESSION_FAILED)
export const createSessionSucceeded = createAction(CREATE_SESSION_SUCCEEDED)

export const destroySession = createAction(DESTROY_SESSION)
export const destroySessionFailed = createAction(DESTROY_SESSION_FAILED)
export const destroySessionSucceeded = createAction(DESTROY_SESSION_SUCCEEDED)

export const createSessionByOauth2 = createAction(CREATE_SESSION_BY_OAUTH2)
export const createSessionByOauth2Failed = createAction(CREATE_SESSION_BY_OAUTH2_FAILED)
export const createSessionByOauth2Succeeded = createAction(CREATE_SESSION_BY_OAUTH2_SUCCEEDED)

export const getDropboxOauthUrl = createAction(GET_DROPBOX_OAUTH_URL)
export const getDropboxOauthUrlFailed = createAction(GET_DROPBOX_OAUTH_URL_FAILED)
export const getDropboxOauthUrlSucceeded = createAction(GET_DROPBOX_OAUTH_URL_SUCCEEDED)

export const getOffice365AccessToken = createAction(GET_OFFICE365_ACCESS_TOKEN)
export const getOffice365AccessTokenFailed = createAction(GET_OFFICE365_ACCESS_TOKEN_FAILED)
export const getOffice365AccessTokenSucceeded = createAction(GET_OFFICE365_ACCESS_TOKEN_SUCCEEDED)

export const refreshSession = createAction(REFRESH_SESSION)
export const refreshSessionFailed = createAction(REFRESH_SESSION_FAILED)
export const refreshSessionSucceeded = createAction(REFRESH_SESSION_SUCCEEDED)

export const clearAppState = createAction(CLEAR_APP_STATE)

export const initAuthKey = createAction(INIT_AUTH_KEY)
